import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/SEO";

export default function ThankYouGuestPassPage() {
  return (
    <div className="min-h-screen pt-24 pb-20 flex items-center justify-center px-4" data-testid="thank-you-guest-pass-page">
      <SEO
        title="Thank You"
        description="Your guest pass request has been received. A Jersey Girls team member will contact you shortly."
        url="/thank-you-3-day-guest-pass"
        noindex={true}
      />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-lg"
      >
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-500/20 flex items-center justify-center">
          <CheckCircle className="w-10 h-10 text-green-500" />
        </div>
        <h1 className="text-3xl md:text-4xl font-heading font-black text-gray-900 mb-4">
          THANK YOU
        </h1>
        <p className="text-gray-600 text-lg mb-2">
          Your guest pass request has been received.
        </p>
        <p className="text-gray-600 mb-8">
          A team member will contact you shortly to get you set up. We look forward to seeing you at the club.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/memberships">
            <Button className="w-full sm:w-auto bg-brand-pink hover:bg-brand-pink-hover text-white font-bold uppercase tracking-wider">
              View Memberships
            </Button>
          </Link>
          <Link to="/locations">
            <Button variant="outline" className="w-full sm:w-auto border-gray-300 text-gray-700 hover:bg-gray-50">
              Find a Location
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
